
export function updateUrlParameter(name, value) {
  const params = new URLSearchParams(window.location.search);
  params.set(name, value);
  window.history.pushState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}

export function getUrlParameter(param) {
  let url = new URL(document.location)
  return url.searchParams.get(param)
}
